import { Modal } from "antd"
import useBearStore from "../../zustand/state"
import download1 from '../../assets/img/download1.png'
import download2 from '../../assets/img/download2.png'
import download3 from '../../assets/img/download3.png'
import qrcode from '../../assets/img/qrcode.png'
import { useState } from "react"

/**
 * 下载 弹框
 */
const SysModalDownload = () => {

  const { downloadDisplay, setDownloadDisplay } = useBearStore();
  const [codeVisible, setCodeVisible] = useState(false);

  /**
   * 下载软件
   * @param {*} type 
   */
  const onClickDownload = (type) => {
    if (type === 'mindcms') {
      window.open('https://storage.mind360.com.cn/app/mindant/manage.zip');
    }
    else if (type === 'mindant') {
      window.open('https://storage.mind360.com.cn/app/mindant/class.zip');
    }
    else if (type === 'mind360') {
      setCodeVisible(true);
    }
  };

  /**
   * 关闭弹框
   */
  const onCancelModal = () => {
    setDownloadDisplay(false);
  };

  /**
   * 关闭二维码弹框
   */
  const onCancelQRcodeModal = () => {
    setCodeVisible(false);
  };

  return <Modal
    centered
    open={downloadDisplay}
    onCancel={onCancelModal}
    footer={null}
    width={690}
    maskClosable={false}
    destroyOnClose={true}
  >
    <div className="w-full">
      <div className="text-center text-xl font-bold">软件下载</div>
      <div className="flex flex-row justify-between mt-8 pb-2">
        <div className="cursor-pointer" style={{ width: '200px' }} onClick={() => { onClickDownload('mindcms') }}>
          <img className="w-full" src={download1} alt="" />
          <div className="w-full text-center mt-4 text-gray-500">新智思维教学管理平台</div>
        </div>
        <div className="cursor-pointer" style={{ width: '200px' }} onClick={() => { onClickDownload('mindant') }}>
          <img className="w-full" src={download2} alt="" />
          <div className="w-full text-center mt-4 text-gray-500">新智思维学生练习平台</div>
        </div>
        <div className="cursor-pointer" style={{ width: '200px' }} onClick={() => { onClickDownload('mind360') }}>
          <img className="w-full" src={download3} alt="" />
          <div className="w-full text-center mt-4 text-gray-500">新智思维家校互动APP</div>
        </div>
      </div>
    </div>

    <Modal
      centered
      open={codeVisible}
      onCancel={onCancelQRcodeModal}
      footer={null}
      width={300}
      maskClosable={false}
      destroyOnClose={true}
    >
      <div className="w-full flex flex-col items-center p-6">
        <div style={{ width: '180px', height: '180px', backgroundImage: `url(${qrcode})`, backgroundSize: '100% 100%' }}></div>
        <div className="mt-2 text-center">微信扫一扫，关注“新智思维课堂”服务号，使用家校共育</div>
      </div>
    </Modal>
  </Modal>
};

export default SysModalDownload;